import { Toggle } from '@cimplico/components';
import { FieldValues, Control, Path, Controller } from 'react-hook-form';

type OtherScheduleToggleProps<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
};

function OtherScheduleToggle<T extends FieldValues>({ control, name }: OtherScheduleToggleProps<T>): JSX.Element {
    return (
        <Controller
            name={name}
            control={control}
            render={(render): JSX.Element => (
                <div>
                    <label className="text-sm block text-gray-700 dark:text-gray-200 font-medium mb-1">Allow on other schedules</label>
                    <Toggle onToggle={(toggled): void => render.field.onChange(toggled)} type="short" defaultEnabled={render.field.value} />
                    <p className="text-xs text-gray-500 dark:text-gray-300">
                        Enabling this will allow the calculation to be assigned to other schedules
                    </p>
                </div>
            )}
        />
    );
}

export default OtherScheduleToggle;
